@if (showCategories() && categoryFirst()) {
    <div
        class="mb-3 flex flex-wrap gap-2"
        role="group"
        aria-label="Explore suggestions by category"
    >
        @for (category of availableCategories(); track category) {
            <button
                qpxButton
                class="category-button"
                [class.icon-only]="isCategoryIconOnly(category)"
                [matButton]="getCategoryButtonAppearance()"
                size="sm"
                [context]="getCategoryButtonContext(category)"
                tone="muted"
                [style.--category-outline]="getCategoryOutline(category)"
                [attr.aria-pressed]="selectedCategory() === category"
                [attr.aria-expanded]="selectedCategory() === category"
                [attr.aria-controls]="`${headingId()}-prompts`"
                (click)="selectCategory(category)"
            >
                <ng-icon
                    qpx
                    matButtonIcon
                    size="sm"
                    [name]="categoryIcons[category]"
                />
                <span [class.sr-only]="isCategoryIconOnly(category)">{{
                    category
                }}</span>
            </button>
        }
    </div>
}

<div [id]="`${headingId()}-prompts`">
    @if (showQuestions()) {
        <header class="header">
            <ng-content select="[suggestionHeading]" />
            @if (heading()) {
                <h2 [id]="headingId()" class="heading">{{ heading() }}</h2>
            }
            @if (showCategoryFilter()) {
                <div class="controls">
                    <qpx-suggestion-category-filter
                        [options]="categoryOptions()"
                        [selected]="selectedCategory()"
                        [appearance]="appearance()"
                        (categorySelected)="selectCategory($event)"
                    />
                    @if (pages.totalPages() > 1) {
                        <qpx-suggestion-pagination
                            [currentPage]="pages.currentPage()"
                            [totalPages]="pages.totalPages()"
                            (previous)="pages.previous()"
                            (next)="pages.next()"
                            (pageSelected)="pages.select($event)"
                        />
                    }
                </div>
            }
            @if (!showCategoryFilter() && pages.totalPages() > 1) {
                <qpx-suggestion-pagination
                    [currentPage]="pages.currentPage()"
                    [totalPages]="pages.totalPages()"
                    (previous)="pages.previous()"
                    (next)="pages.next()"
                    (pageSelected)="pages.select($event)"
                />
            }
        </header>

        <ul
            class="list"
            [class.shadow-xs]="appearance() === 'elevated'"
            [class.outlined]="appearance() === 'outlined'"
            [attr.aria-label]="ariaLabel()"
        >
            @for (question of pages.visible(); track question.id) {
                <li class="item">
                    <button
                        qpxButton="unstyled"
                        class="card"
                        [class.prefill]="question.action === 'prefill'"
                        [attr.aria-describedby]="`${headingId()}-${question.id}-action-description`"
                        (click)="selectQuestion(question)"
                    >
                        @if (showLeadingAvatar()) {
                            <qpx-avatar
                                fallbackIcon="lucideSearch"
                                tone="muted"
                                [colorContext]="
                                    getCategoryColorContext(question.category)
                                "
                            />
                        }
                        <span
                            class="question"
                            [class.compact-rows]="compactRows()"
                            [qpxSuggestionRowFit]="compactRows()"
                            [contentKey]="question.text + question.category"
                            #rowFit="suggestionRowFit"
                        >
                            <span
                                class="question-label"
                                [attr.title]="
                                    compactRows() && rowFit.truncated()
                                        ? question.text
                                        : null
                                "
                                >{{ question.text }}</span
                            >
                            @if (showCategories() && !categoryFirst()) {
                                <span
                                    class="category-line"
                                    aria-hidden="true"
                                    [qpxTooltip]="
                                        compactRows() && rowFit.compact()
                                            ? question.category
                                            : ''
                                    "
                                >
                                    <qpx-pill
                                        tone="muted"
                                        size="sm"
                                        [icon]="question.icon"
                                        [label]="question.category"
                                        [iconOnly]="
                                            compactRows() && rowFit.compact()
                                        "
                                        [context]="
                                            getCategoryColorContext(
                                                question.category
                                            )
                                        "
                                        [darkenIconBackground]="true"
                                    />
                                </span>
                            }
                            @if (
                                compactRows() &&
                                showCategories() &&
                                !categoryFirst()
                            ) {
                                <span
                                    class="question-measure"
                                    aria-hidden="true"
                                    >{{ question.text }}</span
                                >
                                <span
                                    class="category-measure"
                                    aria-hidden="true"
                                >
                                    <qpx-pill
                                        tone="muted"
                                        size="sm"
                                        [icon]="question.icon"
                                        [label]="question.category"
                                        [darkenIconBackground]="true"
                                    />
                                </span>
                            }
                        </span>
                        <ng-icon
                            qpx
                            class="arrow-icon"
                            size="sm"
                            [name]="
                                question.action === 'prefill'
                                    ? 'lucidePencil'
                                    : 'lucideArrowRight'
                            "
                        />
                    </button>
                    <span
                        class="sr-only"
                        [id]="`${headingId()}-${question.id}-action-description`"
                    >
                        @if (compactRows() && showCategories()) {
                            Category: {{ question.category }}.
                        }
                        @if (question.action === 'prefill') {
                            Adds this starter to the message for editing.
                        } @else {
                            Sends this question immediately.
                        }
                    </span>
                </li>
            }
        </ul>
    }
</div>
